import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import RegisterReducer from './RegisterReducer';
import { registerReducerKey } from './RegisterConstants';
import RegisterModal from './RegisterModal';
import { setData, init, submitRegisterModal, resetState, closeRegisterModal } from './RegisterActions';
import {
  ipAddress as ipAddressSelector,
  isLoading as isLoadingSelector,
  data as dataSelector,
  isAnonymousUser as isAnonymousUserSelector,
  isShibboleth as isShibbolethSelector,
  registerFail as registerFailSelector,
} from './RegisterSelectors';

const mapStateToProps = (state) => ({
  ipAddress: ipAddressSelector(state),
  isLoading: isLoadingSelector(state),
  data: dataSelector(state),
  isAnonymousUser: isAnonymousUserSelector(state),
  isShibboleth: isShibbolethSelector(state),
  registerFail: registerFailSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setData: (data) => dispatch(setData(data)),
  init: () => dispatch(init()),
  cancel: () => dispatch(closeRegisterModal()),
  submit: () => dispatch(submitRegisterModal()),
  resetState: () => dispatch(resetState()),
});

export default compose(withReducer(registerReducerKey, RegisterReducer), connect(mapStateToProps, mapDispatchToProps))(RegisterModal);
